var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTrees48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4695 35.5866C15.0428 35.5873 13.1092 35.5935 12.8813 35.5865C9.46114 35.4817 7 31.3769 7 26.5054C7 19.1109 10.6309 12.9383 14.059 11.4905C14.5181 11.2801 14.9924 11.1694 15.4706 11.1694L15.5 11.1699L15.5294 11.1694C16.0076 11.1694 16.4819 11.2801 16.9411 11.4908C20.3691 12.9383 24 19.1109 24 26.5054C24 31.3769 21.5389 35.4817 18.1187 35.5865C17.8908 35.5935 15.9572 35.5873 15.5305 35.5866H15.4695Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.2295V42.9898",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5935 32.6302L12.2676 28.9302",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7196 35.6357C30.2052 35.6366 27.8751 35.6442 27.6005 35.6356C23.4787 35.5063 20.5127 30.4405 20.5127 24.4287C20.5127 15.3033 24.8884 7.68582 29.0197 5.89917C29.5729 5.63956 30.1446 5.50293 30.7209 5.50293L30.7563 5.50356L30.7917 5.50293C31.368 5.50293 31.9396 5.63956 32.493 5.89952C36.6241 7.68582 40.9999 15.3033 40.9999 24.4287C40.9999 30.4405 38.0339 35.5063 33.9121 35.6356C33.6374 35.6442 31.3073 35.6366 30.793 35.6357H30.7196Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1226 20.2036V42.9899",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2148 27.5541L27.9224 23.8789",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1225 30.4945L34.415 26.8193",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTrees48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees48.65b830aeba9fa48e6fc0354f613b633a.svg";
export { ForwardRef as ReactComponent };